__turbopack_context__.v({
  "icon": "ZWME1a_icon",
  "label": "ZWME1a_label",
});
